




import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseComponent from '@/author/components/BaseComponent.vue';

@Component
export default class CloseButton extends BaseComponent {
  @Prop() label!: string;
  @Prop() size!: string;
  @Prop() color!: string;
  closeSuccess: boolean = true;

  created(){
    this.logWithSuccessFlag('Fetching Parent Window', window.opener, this.canClose);
  }

  handleCloseButtonClick(): void {
    this.closeSuccess = window.close() !== undefined;
    this.closeNav();
  }
  get canClose() {
    return this.closeSuccess;
  }
  get customColor() {
    return this.color
      ? { backgroundColor: this.color, borderColor: this.color, color:'#fff' }
      : {};
  }
}
